import webApi, { isBrowser } from '../WebApi';
const getStorage = (storageType = 'localStorage') => {
    const storage = webApi[storageType];
    const getItem = (key) => {
        return isBrowser && storage ? storage.getItem(key) : undefined;
    };
    const setItem = (key, value) => {
        if (isBrowser && storage)
            storage.setItem(key, value);
    };
    return {
        getItem,
        setItem,
    };
};
export { getStorage };
//# sourceMappingURL=storage.js.map